<template>
    <section>
        <div class="page">
            <div>
                <h2>
                    Configuring your privacy settings
                </h2>
                <p>
                    By default, ToTok sets your privacy settings to allow any ToTok user to see your read receipts,last
                    seen and profile phone.
                </p>
                <p>
                    To change these settings, simply go to ToTok > tap <strong>Me</strong> ><strong>Settings</strong>>
                    <strong>Privacy</strong>.
                </p>
                <p>
                    Note:
                </p>
                <ul>
                    <li>
                        If you don't share your last seen, you won't be able to see other people's last seen.
                    </li>
                    <li>
                        If you turn off read receipts, you won't be able to see read receipts from other people. Read
                        receipts are always sent for group chats.
                    </li>
                    <li>
                        If a contact has disabled read receipts, you will not be able to see that they have viewed your
                        status update.
                    </li>
                </ul>


            </div>
        </div>
    </section>
</template>

<script>
    export default {
        components: {},
        data() {
            return {};
        },
        computed: {},
        methods: {}
    }
</script>
